import {useState, useEffect} from "react";
import mainImg from "../Images/logo.png";
// import zeroLogo from "../Images/zero4_logo.jpeg";

const Home = () => {
  const [id, setID] = useState(null);
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [saveIsLoading, setSaveIsLoading] = useState(false);
  const [ticketCalled, setTicketCalled] = useState(false);

  const getTicket = (ID) => {
    setIsLoading(true);
    fetch(`${process.env.REACT_APP_API_BASE_URL}/public/getTicket?transaction_id=${ID}`)
      .then((response) => response.json())
      .then((data) => {
        setData(data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };

  const callMyCar = () => {
    setSaveIsLoading(true);
    fetch(`${process.env.REACT_APP_API_BASE_URL}/public/callVehicle`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({transaction_id: id}),
    })
      .then((response) => response.json())
      .then((data) => {
        setSaveIsLoading(false);
        setTicketCalled(true);
      })
      .catch((error) => {
        console.error(error);
        setSaveIsLoading(false);
      });
  };

  useEffect(() => {
    const getUrlParameter = (name) => {
      const params = new URLSearchParams(window.location.search);
      return params.get(name);
    };
    const idFromUrl = getUrlParameter("ID") || "123456"; // Default ID for demo
    if (idFromUrl) {
      setID(idFromUrl);
      getTicket(idFromUrl);
    }
  }, []);

  // Simple car icon
  const CarIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
      <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z" />
    </svg>
  );

  return (
    <div className="page-container">
      <div className="ticket-card">
        <div className="ticket-header">
          {/* <h1>Parking Ticket</h1> */}
          <img src={mainImg} alt="Parking" className="header-logo" />
          {/* <div className="logo">Z4</div> */}
          {/* <img src={zeroLogo} alt="Z4" style={{width: "70px", borderRadius: "10px"}} /> */}
        </div>
        {isLoading ? (
          <div className="loading">
            <div className="spinner"></div>
            <p>Loading...</p>
          </div>
        ) : (
          <div className="ticket-content">
            <div className="ticket-info">
              <div className="info-section">
                <h2>Parking Details</h2>
                <div className="time-row">
                  <span>Entry:</span>
                  <span>{data?.entry_str || "—"}</span>
                </div>
                <div className="time-row">
                  <span>Exit:</span>
                  <span>{data?.exit_str || "Pending"}</span>
                </div>
              </div>

              <div className="info-section">
                <h2>Payment</h2>
                <div className="payment-row">
                  <span>Status:</span>
                  <span className={data?.status === "paid" ? "status-paid" : ""}>
                    {data?.status === "paid" ? "Paid" : "Unpaid"}
                  </span>
                </div>
                <div className="payment-row">
                  <span>Amount:</span>
                  <span className="amount">{data?.paid_amount} L.L</span>
                </div>
              </div>
            </div>

            <div className="action-area">
              {!ticketCalled ? (
                <button className="call-button" onClick={callMyCar} disabled={saveIsLoading}>
                  {saveIsLoading ? (
                    <span className="loading-text">Processing...</span>
                  ) : (
                    <>
                      <CarIcon /> Call My Car
                    </>
                  )}
                </button>
              ) : (
                <div className="success-message">
                  <div className="checkmark">✓</div>
                  <p>Your car has been called!</p>
                </div>
              )}
            </div>

            <div className="ticket-footer">
              <p className="ticket-id">Ticket #{id || "000000"}</p>
            </div>
          </div>
        )}
      </div>

      <style jsx>{`
        .page-container {
          width: 100%;
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #f0f2f5;
          padding: 20px;
          box-sizing: border-box;
          font-family:
            -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
        }

        .ticket-card {
          width: 100%;
          max-width: 450px;
          background: white;
          border-radius: 8px;
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
          overflow: hidden;
        }

        .ticket-header {
          background-color: #1e40af;
          color: white;
          padding: 16px 20px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .header-logo {
          display: block;
          width: 200px;
          max-width: 100%;
          height: 120px;
          object-fit: cover;

          border-radius: 10px;
        }

        .ticket-header h1 {
          margin: 0;
          font-size: 22px;
          font-weight: 500;
        }

        .logo {
          background: white;
          color: #1e40af;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          font-size: 16px;
        }

        .loading {
          padding: 40px 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        .spinner {
          width: 30px;
          height: 30px;
          border: 3px solid rgba(0, 0, 0, 0.1);
          border-top-color: #1e40af;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }

        .ticket-content {
          padding: 20px;
        }

        .ticket-info {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .info-section {
          background-color: #f8fafc;
          border-radius: 6px;
          padding: 16px;
        }

        .info-section h2 {
          margin: 0 0 12px 0;
          font-size: 16px;
          color: #475569;
          font-weight: 500;
        }

        .time-row,
        .payment-row {
          display: flex;
          justify-content: space-between;
          margin-bottom: 8px;
          font-size: 15px;
        }

        .status-paid {
          color: #16a34a;
          font-weight: 500;
        }

        .amount {
          font-weight: 600;
          font-size: 16px;
          color: #1e40af;
        }

        .action-area {
          margin-top: 24px;
          display: flex;
          justify-content: center;
        }

        .call-button {
          background-color: #1e40af;
          color: white;
          border: none;
          border-radius: 6px;
          padding: 12px 24px;
          font-size: 16px;
          font-weight: 500;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 8px;
          min-width: 160px;
          justify-content: center;
          transition: background-color 0.2s;
        }

        .call-button:hover {
          background-color: #1e3a8a;
        }

        .call-button:disabled {
          background-color: #94a3b8;
          cursor: not-allowed;
        }

        .loading-text {
          font-size: 15px;
        }

        .success-message {
          text-align: center;
          color: #16a34a;
        }

        .checkmark {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #16a34a;
          color: white;
          font-size: 22px;
          margin: 0 auto 12px;
        }

        .ticket-footer {
          margin-top: 24px;
          padding-top: 16px;
          border-top: 1px solid #e2e8f0;
          text-align: center;
        }

        .ticket-id {
          margin: 0;
          color: #64748b;
          font-size: 14px;
        }
      `}</style>
    </div>
  );
};

export default Home;
